import Receipt from './EmployeeExpenseReceipt';
export default class UserExpense {
    amount?: string;
    code?: string;
    description?: string;
    esId?: number;
    mileage?: number;
    droveFrom?: string;
    droveTo?: string;
    otherDescription?: string;
    receipts?: Receipt[];
    tmId?: number;
}


// WEBPACK FOOTER //
// ./src/models/AP/EmployeeExpense.ts